import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static targets = ['fileName']

  getFileName(event){
    this.fileNameTarget.innerHTML = event.currentTarget.files[0].name
  }
}
